<template>
  <div class="status-images">
    <template v-if="value">
      <tooltip
        class="status-image"
        v-if="value.ok"
        title="ОК"
        placement="right"
      >
        <img src="~img/machine-statuses/check-icon.svg"/>
      </tooltip>
      <tooltip
        class="status-image"
        v-if="value.network"
        title="Нет связи"
        placement="right"
      >
        <img src="~img/machine-statuses/wifi-icon.svg"/>
      </tooltip>
      <tooltip
        class="status-image"
        v-if="value.products"
        title="Требуется загрузка"
        placement="right"
      >
        <img src="~img/machine-statuses/arrow.svg"/>
      </tooltip>
      <tooltip
        class="status-image"
        v-if="value.money"
        title="Требуется инкассация"
        placement="right"
      >
        <img src="~img/machine-statuses/ruble.svg"/>
      </tooltip>
      <tooltip
        class="status-image"
        v-if="value.shake"
        title="Тряска"
        placement="right"
      >
        <img src="~img/machine-statuses/jolt.svg"/>
      </tooltip>
      <tooltip
        class="status-image"
        v-if="value.temperature"
        title="Достижение порогового значения температуры внутри автомата"
        placement="right"
      >
        <img src="~img/machine-statuses/temperature.svg"/>
      </tooltip>
      <tooltip
        class="status-image"
        v-if="value.electricity"
        title="Отсутствие электропитания от сети 220В"
        placement="right"
      >
        <img src="~img/machine-statuses/power.svg"/>
      </tooltip>
      <tooltip
        class="status-image"
        v-if="value.eva"
        title="Большое кол-во отчетов EVA-DTS с ошибками"
        placement="right"
      >
        <img src="~img/machine-statuses/error.svg"/>
      </tooltip>
      <tooltip
        class="status-image"
        v-if="value.service"
        title="Невыполненный сервис"
        placement="right"
      >
        <img src="~img/machine-statuses/car-icon.svg"/>
      </tooltip>
      <tooltip
        class="status-image"
        v-if="value.stop"
        title="Остановка по причине неисправности"
        placement="right"
      >
        <img src="~img/machine-statuses/stop.svg"/>
      </tooltip>
      <tooltip
        class="status-image"
        v-if="value.ignore"
        title="Давно не на связи"
        placement="right"
      >
        <img src="~img/machine-statuses/no-connection-new.svg"/>
      </tooltip>

      <tooltip
        class="status-image"
        v-if="hasReason('technical')"
        title="Простой: Технический"
        placement="right"
      >
        <img src="~img/machine-statuses/downtimes-technical.svg"/>
      </tooltip>

      <tooltip
        class="status-image"
        v-if="hasReason('ingredients')"
        title="Простой: отсутствие ингредиентов"
        placement="right"
      >
        <img src="~img/machine-statuses/downtimes-ingredients.svg"/>
      </tooltip>

      <tooltip
        class="status-image"
        v-if="hasReason('money')"
        title="Простой: отсутствие сдачи"
        placement="right"
      >
        <img src="~img/machine-statuses/downtimes-money.svg"/>
      </tooltip>

      <tooltip
        class="status-image"
        v-if="hasReason('unspecified')"
        title="Простой: требует уточнения"
        placement="right"
      >
        <img src="~img/machine-statuses/downtimes-unspecified.svg"/>
      </tooltip>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'status-images',
    props: {
      value: {},
      reasons: [],
    },
    methods: {
      hasReason (reason) {
        return this.reasons.includes(reason)
      }
    }
  }
</script>

<style lang="scss">
  @import "boot";
  .status-image {
    float: left;
    img {
      @include size(2em);
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/status-images.vue